import Class from './c-content-chart-linear-marker';
import './c-content-chart-linear-marker@.vue';

export default Class;